//==============================
// Age Gate
//==============================

var ageGate = $('.age-gate');

function showAgeGate() {
  if (Cookies.get("age-gate") == "SET") {} else {
    ageGate.removeClass('hidden');

    // setTimeout(function() {
    //   newsletterPopup.find('.age-gate-inner').focus();
    // }, 3000);
  }
}

function hideAgeGate() {
  Cookies.set("age-gate", "SET", { expires: 30 });
  ageGate.addClass('hidden');
  setTimeout(function() {
    $('.header').focus();
  }, 1);
  setTimeout(function() {
    showNewsletter();
  }, 500);
}

$(window).on('load', function() {
    if(body.hasClass('home')) {
      showAgeGate(100);
    } else {
      showAgeGate(0);
    }
});

$('.js-age-gate-close').click(function() {
  hideAgeGate();
  return false;
});

// ageGate.click(function() {
//   hideAgeGate();
// });

// ageGate.find('.button').click(function() {
//   hideAgeGate();
// });

